export default {
      id: "icon_barbell-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "sprite.svg#icon_barbell",
      toString: function () {
        return this.url;
      }
    }